export default __webpack_public_path__ + "static/media/B0002.56f3dca5.png";